module.exports = __webpack_public_path__ + "static/media/icon-download.c99d6079.svg";